<template>
    <div>
        <button
            v-if="!selectedStore"
            type="button large"
            class="button"
            :class="{'set-width': !selectedStore}"
            data-open="locatorModal"
        >
            Select a Store
        </button>
        <hr v-if="!selectedStore" class="b-margin">
        <button
            type="button large"
            class="button"
            :class="{'set-width': !selectedStore}"
            data-open="scheduleModal"
        >
            Request an Appointment
        </button>
        <hr v-if="selectedStore">
        <p v-if="selectedStore" class="text-center call-text-p">
            <strong>Have Questions?</strong> Call: <span><a v-bind:href="'tel:' + phone">{{ phone }}</a></span>
        </p>
    </div>
</template>

<style lang="scss" scoped>
@import '~@styles/scss/base/variables';
hr {
    margin: 0;
    border-top: 1px solid #000000;
}
.b-margin {
    margin-bottom: 1rem;
}
.set-width {
    width: 226px;
}
.call-text-p {
    margin-top:.5em; 
    border-top:1px solid #cacaca; 
    padding-top:.5em;
    span {
        color: $color1;
        display: inline-block;
    }
}
</style>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapState, mapActions } = createNamespacedHelpers('location');
export default {
    computed: {
        ...mapState(['selectedStore']),
        phone() {
			if (this.selectedStore) {
                return this.selectedStore.phone;
            }
			return '';
		}
    },
    mounted: function() {
        this.requireSelectedStore();
    },
    methods: {
        ...mapActions(['requireSelectedStore']),
    }
}
</script>